import { useState } from 'react'
import { COUNTRY_CODE_ES } from '../../../utils/Constants'
import usePaginationModel from '../../../hooks/usePaginationModel'
import useSortModel from '../../../hooks/useSortModel'
import { GridRowId } from '@mui/x-data-grid-premium'

const TrackingKeywordsModel = () => {
  const [ isLoading, setIsLoading ] = useState<Record<string, boolean>>({ search: false, keywords: false  });
  const [ projectsLoaded, setProjectsLoaded ] = useState<boolean>(false)
  const [ projects, setProjects ] = useState<[]>([])
  const [ projectSelected, setProjectSelected ] = useState<[]>()
  const [ limitProjects, setLimitProjects ] = useState<number>(0)
  const [ limitKeywords, setLimitKeywords ] = useState<number>(0)
  const limitProjectsExceeded = projects.length > limitProjects
  const limitKeywordsExceeded = projects.reduce((sum, p) => sum + (p.total || 0), 0) > limitKeywords
  const [ keywords, setKeywords ] = useState<[]>([])
  const [ serps, setSerps ] = useState<[]>([])
  const [ totalKeywords, setTotalKeywords ] = useState<number>(0)
  const [ sov, setSov ] = useState<number>(0)
  const [ ranges, setRanges ] = useState<any>()
  const [ inputNewKeywords, setInputNewKeywords ] = useState<string>('')
  const [ searchEngine, setSearchEngine ] = useState<String>('google')
  const [ device, setDevice ] = useState('desktop');
  const [ os, setOs ] = useState('windows');
  const [ isAiOverview, setIsAiOverview ] = useState<boolean>(false)
  const [ showAiOverview, setShowAiOverview ] = useState<boolean>(false)
  const [ country, setCountry ] = useState<{
    country: string,
    language: string
  }>({country: COUNTRY_CODE_ES, language: 'es'})
  const [ selectionModel, setSelectionModel ] = useState<GridRowId[]>([]);

  const [ language, setLanguage ] = useState<String>('es')
  const osOptions = {
    desktop: ['windows', 'macos'],
    mobile: ['ios', 'android']
  };

  // Pagination and Sorting in server side
  const { paginationModel, setPaginationModel } = usePaginationModel()
  const { sortModel, setSortModel } = useSortModel()

  return {
    isLoading, setIsLoading,
    projectsLoaded, setProjectsLoaded,
    projects, setProjects,
    projectSelected, setProjectSelected,
    limitProjects, setLimitProjects, limitProjectsExceeded,
    limitKeywords, setLimitKeywords, limitKeywordsExceeded,
    searchEngine, setSearchEngine,
    keywords, setKeywords, totalKeywords, setTotalKeywords,
    serps, setSerps,
    inputNewKeywords, setInputNewKeywords,
    device, setDevice,
    os, setOs,
    osOptions,
    country, setCountry,
    language, setLanguage,
    paginationModel, setPaginationModel,
    sortModel, setSortModel,
    sov, setSov, ranges, setRanges,
    isAiOverview, setIsAiOverview ,
    showAiOverview, setShowAiOverview,
    selectionModel, setSelectionModel
  }
}

export default TrackingKeywordsModel;